import { render, staticRenderFns } from "./requirementList.vue?vue&type=template&id=4fcb7625&"
import script from "./requirementList.vue?vue&type=script&lang=ts&"
export * from "./requirementList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports